/**
 * Canvas settings every WebGL section shares, from the prototype's config.js
 * (`CONFIG.bg`, `CONFIG.render`).
 */
export const GL_BG = "#f4f4f4";

export const GL_RENDER = {
    /** Cap on devicePixelRatio for the drawing buffer. */
    dprMax: 2,
    /** Gradient buffer resolution, as a fraction of the canvas. */
    gradScale: 0.55,
    /** Blur buffer resolution, as a fraction of the canvas. */
    blurScale: 0.25,
    /** Anti-banding noise, in 1/255 units. */
    dither: 1.4,
} as const;
